export default __webpack_public_path__ + "static/media/card8.6b1455bb.png";